import { BCExtremeGridEntities } from '@bimser/components';
import { ReadonlyRecord } from '@bimser/core';
import { List, Record } from 'immutable';
import {
	IDmActionMenuItem,
	DmActionMenuItem,
	DmActionMenuItemFactoryFromJS
} from './IDmActionMenuItem';
import { IDmData, DmData, DmDataFactoryFromJS, DMListView } from '@bimser/common';
import {
	ISearchOptions,
	SearchOptions,
	SearchOptionsFactoryFromJS
} from '../../components/dashboard/components/advancedSearch/entities/SearchOptions';
import EExplorerViewType from '../../components/explorer/entities/EExplorerViewType';

export interface IBaseDmScene {
	showMode: EExplorerViewType;
	name: string;
	id: string;
	isActive: boolean;
	secretKey?: string;
	contextMenuVisibleOn?: string;
	hasMoreItems?: boolean;
	isLoadingMore?: boolean;
	refreshKey?: string;
	totalCount?: number;
}

export interface IDmScene extends IBaseDmScene {
	items: Array<string>;
	gridItems: Array<string>;
	contextMenuActions: Array<string>;
	topbarActions: Array<IDmActionMenuItem>;
	topbarOverflowActions: Array<IDmActionMenuItem>;
	selectedItems: Array<string>;
	loadOptions: BCExtremeGridEntities.ILoadOptions;
	gridContext: Array<DMListView.IGridContextItem>;
	parents: Array<IDmData>;
	searchOptions?: ISearchOptions;
}

export interface IReadonlyDmScene extends IBaseDmScene {
	items: List<string>;
	gridItems: List<string>;
	contextMenuActions: List<string>;
	topbarActions: List<DmActionMenuItem>;
	topbarOverflowActions: List<DmActionMenuItem>;
	selectedItems: List<string>;
	loadOptions: BCExtremeGridEntities.LoadOptions;
	gridContext: List<DMListView.GridContextItem>;
	parents: List<DmData>;
	searchOptions?: SearchOptions;
}

export type DmScene = ReadonlyRecord<IReadonlyDmScene>;

export const DmSceneFactory = Record<IReadonlyDmScene>({
	showMode: EExplorerViewType.List,
	name: '',
	id: '',
	secretKey: '',
	isActive: false,
	hasMoreItems: true,
	isLoadingMore: false,
	refreshKey: '',
	selectedItems: List(),
	items: List(),
	gridItems: null,
	loadOptions: BCExtremeGridEntities.LoadOptionsFactory(),
	gridContext: List(),
	parents: List(),
	contextMenuVisibleOn: null,
	contextMenuActions: List(),
	topbarActions: List(),
	topbarOverflowActions: List(),
	totalCount: null,
	searchOptions: null
});

export const DmSceneFactoryFromJS = function (scene: IDmScene) {
	const _gridContext: Array<DMListView.GridContextItem> =
		scene && scene.gridContext
			? scene.gridContext.map(i => DMListView.GridContextItemFactoryFromJS(i))
			: [];
	const _parents: Array<DmData> =
		scene && scene.parents ? scene.parents.map(i => DmDataFactoryFromJS(i)) : [];
	const _topbarOverflowActions: Array<DmActionMenuItem> =
		scene && scene.topbarOverflowActions
			? scene.topbarOverflowActions.map(i => DmActionMenuItemFactoryFromJS(i))
			: [];
	const _topbarActions: Array<DmActionMenuItem> =
		scene && scene.topbarActions
			? scene.topbarActions.map(i => DmActionMenuItemFactoryFromJS(i))
			: [];
	const searchOptions = scene.searchOptions
		? SearchOptionsFactoryFromJS(scene.searchOptions)
		: null;

	return DmSceneFactory({
		...scene,
		items: List(scene.items),
		selectedItems: List(scene.selectedItems),
		loadOptions: BCExtremeGridEntities.LoadOptionsFactoryFromJS(scene.loadOptions),
		gridContext: List(_gridContext),
		parents: List(_parents),
		contextMenuActions: List(scene.contextMenuActions),
		topbarActions: List(_topbarActions),
		topbarOverflowActions: List(_topbarOverflowActions),
		gridItems: List(scene.gridItems),
		searchOptions
	});
};
